import { useEffect, useRef } from "react";
import gsap from "gsap";
import { TIME_HORIZONS } from "@/constants/data";
import { SelectionCard } from "@/components/SelectionCard";
import { StickyCTA } from "@/components/StickyCTA";

export const TimeHorizonScreen = ({ selected, onSelect, onContinue, onBack }) => {
  const headerRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(headerRef.current?.children || [], {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.07,
      });
      gsap.from(gridRef.current?.children || [], {
        opacity: 0,
        y: 24,
        duration: 0.55,
        ease: "power3.out",
        stagger: 0.07,
        delay: 0.15,
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <section className="min-h-[calc(100vh-100px)] pt-4 md:pt-6 pb-8 md:pb-10 px-6 md:px-10 lg:px-16 2xl:px-24 max-w-7xl 3xl:max-w-[1600px] mx-auto flex flex-col">
      <div ref={headerRef} className="relative text-center mb-8 md:mb-10">
        <button
          type="button"
          onClick={onBack}
          data-testid="back-button"
          className="absolute left-0 top-0 z-10 text-xs tracking-[0.18em] uppercase text-zinc-500 dark:text-zinc-500 hover:text-zinc-900 dark:hover:text-zinc-300 transition-colors"
        >
          ← Back
        </button>
        <p className="text-xs tracking-[0.24em] uppercase text-zinc-500 dark:text-zinc-500 font-semibold mb-2">
          Step 02 — Timeline
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl font-medium tracking-tighter text-zinc-900 dark:text-zinc-50 leading-[1.05] font-display">
          When do you want to{" "}
          <span className="text-brand">achieve this?</span>
        </h1>
        <p className="text-sm md:text-base text-zinc-600 dark:text-zinc-400 mt-2.5 max-w-2xl mx-auto">
          Time bends money. The longer the runway, the lighter the load.
        </p>
      </div>

      <div
        ref={gridRef}
        className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 flex-1 content-start max-w-5xl w-full mx-auto"
      >
        {TIME_HORIZONS.map((t, i) => (
          <SelectionCard
            key={t.id}
            testId={`time-horizon-card-${t.id}`}
            title={t.label}
            hint={t.hint}
            meta={`${t.years} years`}
            selected={selected?.id === t.id}
            onClick={() => onSelect(t)}
            index={i}
          />
        ))}
      </div>

      <StickyCTA
        label={selected ? "Continue" : "Pick a horizon"}
        disabled={!selected}
        onClick={onContinue}
      />
    </section>
  );
};
